import React from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import styled from 'styled-components';

export type ToggleMonth = {
    label: string;
    value: number;
};

export type radioData = {
    id: string;
    label: string;
};

type Step3ToggleMonthProps = {
    monthList: ToggleMonth[];
    month: ToggleMonth | undefined;
    onChange: (month: ToggleMonth | undefined) => void;
};

type Step4ToggleYearProps = {
    yearList: number[];
    year: number | undefined;
    onChange: (year: number | undefined) => void;
};

type Ste3ToggleRadioGroupProps = {
    radioList: radioData[];
    selected: string;
    onChange: (year: string) => void;
};

const ModifiedDropdown = styled(MenuList)`
    & > div > p {
        color: black;
    }
`;

export const Step4ToggleOpenMonth = ({
    monthList,
    month,
    onChange,
}: Step3ToggleMonthProps) => {
    return (
        <div>
            <ModifiedDropdown
                // placeholder="Month" // TODO: FIX
                style={{
                    width: '94px',
                    height: '40px',
                    padding: '1px 15px',
                }}
            >
                {monthList.map((currentMonth, index) => (
                    <MenuItem
                        key={`monthItem${currentMonth.value}`}
                        value={currentMonth.value}
                        selected={monthList.some(
                            (monthInList) => monthInList.value === month?.value,
                        )}
                        onClick={(_e) =>
                            onChange(
                                monthList.find(
                                    (_m, monthIndex) => monthIndex === index,
                                ),
                            )
                        }
                    >
                        {currentMonth.label}
                    </MenuItem>
                ))}
            </ModifiedDropdown>
        </div>
    );
};

export const Step4ToggleOpenYear = ({
    yearList,
    year,
    onChange,
}: Step4ToggleYearProps) => {
    return (
        <div>
            <ModifiedDropdown
                // placeholder="Year"// TODO: FIX
                style={{
                    width: '94px',
                    height: '40px',
                    padding: '1px 15px',
                }}
            >
                {yearList.map((currentYear, currentYearIndex) => (
                    <MenuItem
                        key={`yearItem${currentYear}`}
                        value={currentYear}
                        selected={yearList.some(
                            (yearInList) => yearInList === year,
                        )}
                        onClick={(_e) =>
                            onChange(
                                yearList.find(
                                    (_m, yearIndex) =>
                                        yearIndex === currentYearIndex,
                                ),
                            )
                        }
                    >
                        {currentYear}
                    </MenuItem>
                ))}
            </ModifiedDropdown>
        </div>
    );
};

export const Step3ToggleRadioGroup = ({
    radioList,
    selected,
    onChange,
}: Ste3ToggleRadioGroupProps) => {
    const onChangeRadioOption = (radioOption: string) => {
        if (selected !== radioOption) onChange(radioOption);
    };
    return (
        <RadioGroup sx={{ gap: 3 }}>
            {radioList.map((radio, index) => (
                <FormControlLabel
                    key={`step3-radio-button-${index + 1}`}
                    control={<Radio size="small" />}
                    color="secondary"
                    onChange={() => onChangeRadioOption(radio.id)}
                    checked={selected === radio.id}
                    label={radio.label}
                />
            ))}
        </RadioGroup>
    );
};
